import React from "react";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import * as HiIcons from "react-icons/hi";

export const AdminSidebarData = [
  {
    title: "Home",
    id: "spy1",
    to: "title",
    cName: "nav-text",
    icon: <AiIcons.AiFillHome />,
    display: true,
  },
  {
    title: "Update Database",
    id: "spy2",
    to: "databaseUpdate",
    cName: "nav-text",
    icon: <AiIcons.AiFillDatabase />,
    display: true,
  },
  {
    title: "Add Bulk Users",
    id: "spy3",
    to: "bulkUsers",
    cName: "nav-text",
    icon: <HiIcons.HiUsers />,
    display: true,
  },
  {
    title: "Table Export",
    id: "spy4",
    to: "tableExport",
    cName: "nav-text",
    icon: <FaIcons.FaTable />,
    display: true,
  },
  {
    title: "File Input",
    id: "spy5",
    to: "fileInput",
    cName: "nav-text",
    icon: <FaIcons.FaFileExcel />,
    display: true,
  },
];
